export interface Award {
  id: string;
  name: string;
  awardingBody: string;
  year: number;
  category: string;
  badgeImageUrl?: string;
  description?: string;
}

// TODO(content): populate once ZenFresh actually receives a real award or
// industry recognition. Deliberately empty — an invented awarding body and
// award name would be a specific, checkable false credibility claim, the
// same reasoning as pressMentions.ts. AwardsShowcase.tsx hides this section
// entirely while empty, per this ticket's own AC (not just this project's
// usual "coming soon" default — the AC explicitly asks for no empty state).
export const AWARDS: Award[] = [];
